import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const noIndexUrls = [environment.contactPage];
if (environment.apiUrl) {
  const index = noIndexUrls.findIndex((url) => environment.apiUrl.startsWith(url));
  if (index !== -1) {
    const metaElement = document.createElement('meta');
    metaElement.name = 'robots';
    metaElement.content = 'noindex';
    document.head.appendChild(metaElement);
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
